import {
  type LatestWorkerMovement,
  type TripStatus,
} from "../../containers/facilityDashboard/ShiftCalendar/dayView/workerETA/types";
import { type TimeSlot, type UrgencyType } from "../Shifts/types";

export interface DateTimeSlot {
  date: Date;
  timeSlot: TimeSlot;
}

export interface DateInterval {
  start: Date;
  end: Date;
}

export interface ShiftBoardWorkplace {
  id: string;
  name: string;
  timeZone: string;
}

export interface ShiftBoardWorker {
  id: string;
  name: string;
  avatarUrl: string | undefined;
}

export interface ShiftBoardShiftBase {
  id: string;
  qualification: string;
  start: Date;
  end: Date;
  timeslot: TimeSlot;
  clockInOut:
    | {
        clockIn: Date | undefined;
        clockOut: Date | undefined;
      }
    | undefined;
  verified: boolean;
  deleted: boolean;
  isBillable?: boolean | undefined;
  urgency: UrgencyType | undefined;
  urgentlyBooked: boolean | undefined;
  extendBookabilityTo: Date | undefined;
  workerLeftEarlyRequest:
    | {
        id: string;
        leftWithPermission: boolean;
        replacementRequested: boolean;
      }
    | undefined;
  attendance:
    | {
        leftFacilityGeofence: boolean | undefined;
        arrivedFacilityGeofenceAt: Date | undefined;
        leftFacilityGeofenceAt: Date | undefined;
        isWorkerFarFromFacility: boolean | undefined;
      }
    | undefined;
  worker: ShiftBoardWorker | undefined;
}

export interface ShiftBoardTrip {
  id: string;
  // ETA members are undefined for trips without a provider journey (fact-only trips, ALCH-6955);
  // consumers fall back to their "waiting on ETA" states.
  eta: {
    distanceInM: number | undefined;
    durationInMin: number | undefined;
  };
  initialEta: {
    distanceInM: number | undefined;
    durationInMin: number | undefined;
  };
  status: TripStatus;
  workerDeclaredEta: Date | undefined;
  latestWorkerMovement: LatestWorkerMovement;
  lastLocationReceivedByServerAt: Date | undefined;
  trackingUrl: string | undefined;
  isLate: boolean;
}

export interface ShiftBoardShiftLogs {
  id: string;
  performedBy:
    | {
        type: string | undefined;
        name: string | undefined;
      }
    | undefined;
  action: string;
  subAction: string | undefined;
  eventAt: Date | undefined;
  worker:
    | {
        id: string | undefined;
        name: string | undefined;
      }
    | undefined;
}

export interface ShiftBoardShift extends ShiftBoardShiftBase {
  trip: ShiftBoardTrip | undefined;
  logs: ShiftBoardShiftLogs[];
}

// eslint-disable-next-line no-restricted-syntax
export enum ShiftAction {
  SHIFT_OPEN = "SHIFT_OPEN",
  SHIFT_CLAIM = "SHIFT_CLAIM",
  FACILITY_CANCEL_FILLED = "FACILITY_CANCEL_FILLED",
  FACILITY_CANCEL = "FACILITY_CANCEL",
  WORKER_CANCEL = "WORKER_CANCEL",
  NO_CALL_NO_SHOW = "NO_CALL_NO_SHOW",
  SHIFT_UNASSIGN = "SHIFT_UNASSIGN",
  REPLACEMENT_SHIFT_POSTED = "REPLACEMENT_SHIFT_POSTED",
  MARKED_AS_NON_URGENT = "MARKED_AS_NON_URGENT",
}

// eslint-disable-next-line no-restricted-syntax
export enum ShiftSubAction {
  SELF_NO_CALL_NO_SHOW = "SELF_NO_CALL_NO_SHOW",
  REPLACEMENT_REQUESTED = "REPLACEMENT_REQUESTED",
  NO_CALL_NO_SHOW = "NO_CALL_NO_SHOW",
  WORKER_LEFT_EARLY_WITHOUT_PERMISSION = "WORKER_LEFT_EARLY_WITHOUT_PERMISSION",
  WORKER_LEFT_EARLY_WITH_PERMISSION = "WORKER_LEFT_EARLY_WITH_PERMISSION",
}
